import React, { useEffect, useState } from "react"
import Navbar from "../components/Navbar"
import News from "../components/News"
import Footer from "../components/Footer"
import {
  Container,
  Wrapper,
  Title,
  Bottom,
  Info,
  Summary,
  Product,
  ProductDetails,
  Image,
  Details,
  ProductName,
  ProductId,
  PriceDetail,
  ProductAmountContainer,
  ProductAmount,
  ProductPrice,
  Hr,
  SummaryTitle,
  SummaryItem,
  SummaryItemText,
  SummaryItemPrice,
  Button,
} from "../styles/CartStyle"
import Remove from "@mui/icons-material/Remove"
import Add from "@mui/icons-material/Add"
import { useSelector } from "react-redux"
import StripeCheckout from "react-stripe-checkout"
import { serverAPI } from "../services/apiParams"

const Key = process.env.REACT_APP_STRIPE

const Cart = () => {
  const cart = useSelector((state) => state.cart)
  const [stripeToken, setStripeToken] = useState(null)

  const onToken = (token) => {
    setStripeToken(token)
  }

  useEffect(() => {
    const makePayment = async () => {
      try {
        await serverAPI.post("api/payment", {
          amount: cart.total * 100,
          tokenId: stripeToken.id,
        })
        //save order in the DB
        saveOrder()
      } catch (error) {
        console.log(error.response)
      }
    }
    stripeToken && makePayment()
  }, [stripeToken])

  const saveOrder = async () => {
    try {
      await serverAPI.post("api/orders", { cart, stripeToken })
    } catch (error) {
      console.log(error.response)
    }
  }

  return (
    <Container>
      <News />
      <Navbar />
      <Wrapper>
        <Title>Your Cart</Title>
        <Bottom>
          <Info>
            {cart.products.map((product) => (
              <Product>
                <ProductDetails>
                  <Image src={product.image} />
                  <Details>
                    <ProductName>
                      <b>Products:</b>
                      {product.title}
                    </ProductName>
                    <ProductId>
                      <b>ID: </b>
                      {product.id}
                    </ProductId>
                  </Details>
                </ProductDetails>
                <PriceDetail>
                  <ProductAmountContainer>
                    <Add />
                    <ProductAmount>{product.quantity}</ProductAmount>
                    <Remove />
                  </ProductAmountContainer>
                  <ProductPrice>Price: {product.price}</ProductPrice>
                  <ProductPrice>
                    Total: {product.price * product.quantity}
                  </ProductPrice>
                </PriceDetail>
              </Product>
            ))}
            <Hr />
          </Info>
          <Summary>
            <SummaryTitle>Order Summary</SummaryTitle>
            <SummaryItem>
              <SummaryItemText>Subtotal</SummaryItemText>
              <SummaryItemPrice>${cart.total}</SummaryItemPrice>
            </SummaryItem>
            <SummaryItem>
              <SummaryItemText>Shipping</SummaryItemText>
              <SummaryItemPrice>$0 </SummaryItemPrice>
            </SummaryItem>
            <SummaryItem type='total'>
              <SummaryItemText>Total</SummaryItemText>
              <SummaryItemPrice>${cart.total}</SummaryItemPrice>
            </SummaryItem>
            <StripeCheckout
              name='Store'
              billingAddress
              shippingAddress
              description={`Total : ${cart.total}`}
              amount={cart.total * 100}
              token={onToken}
              stripeKey={Key}>
              <Button>Checkout</Button>
            </StripeCheckout>
          </Summary>
        </Bottom>
      </Wrapper>
      <Footer />
    </Container>
  )
}

export default Cart
